import React from "react";
import "./App.css";
import Rows from "./Rows";
import request from "./request";
import Banner from "./Banner";
import Nav from "./Nav";
function App() {
  return (
    <div className="app">
      <Nav />
      <Banner />
      <Rows title="Trending Now" fetchUrL={request.fetchTrending} islargeRow />
      <Rows title="Upcoming Movies" fetchUrL={request.fetchNetflixOrignals} />
      <Rows title="Top Rated" fetchUrL={request.fetchTopRated} />
      <Rows title="Action Movies" fetchUrL={request.fetchActionMovies} />
      <Rows title="Comedy Movies" fetchUrL={request.fetchComedy} />
      <Rows title="Horror Movies" fetchUrL={request.fetchHoror} />
      <Rows title="Romance Movies" fetchUrL={request.fetchRomance} />
      <Rows title="Documentaries" fetchUrL={request.fetchDocumantaries} />
    </div>
  );
}

export default App;
